

// Компонент - объект с наименованием дороги и направления на странице "Выбор дорог и направлений"
export function EmptyItem() {
    return (
        <div className="roads-list-empty-item" >
            <span>Результатов не найдено</span>
        </div>
    )
}
